// @ts-ignore:next-line
import { useShowCallout } from '@folio/stripes-acq-components';
var DEFAULT_TIMEOUT = 6000;
export var MESSAGE_TYPES;
(function (MESSAGE_TYPES) {
    MESSAGE_TYPES["INFO"] = "info";
    MESSAGE_TYPES["ERROR"] = "error";
    MESSAGE_TYPES["SUCCESS"] = "success";
    MESSAGE_TYPES["WARNING"] = "warning";
})(MESSAGE_TYPES || (MESSAGE_TYPES = {}));
export var useMessages = function () {
    var showCallout = useShowCallout();
    var showMessage = function (type, value) {
        var message = value.message, _a = value.timeout, timeout = _a === void 0 ? DEFAULT_TIMEOUT : _a;
        showCallout({ type: type, message: message, timeout: timeout });
    };
    var showSuccessMessage = function (value) {
        showMessage(MESSAGE_TYPES.SUCCESS, value);
    };
    var showErrorMessage = function (value) {
        showMessage(MESSAGE_TYPES.ERROR, value);
    };
    var showInfoMessage = function (value) {
        showMessage(MESSAGE_TYPES.INFO, value);
    };
    var showWarningMessage = function (value) {
        showMessage(MESSAGE_TYPES.WARNING, value);
    };
    return {
        showWarningMessage: showWarningMessage,
        showMessage: showMessage,
        showSuccessMessage: showSuccessMessage,
        showErrorMessage: showErrorMessage,
        showInfoMessage: showInfoMessage
    };
};
